// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_sr-0";
export var checkoutRateBadgeLink = "_sr-1";